import { useIntl } from 'react-intl'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import styled from 'styled-components'
import { rem } from 'polished'

const IconContainer = styled.div`
  width: ${rem(48)};
  height: ${rem(48)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  color: ${props => props.theme.palette.highlight.primary.lightContrast};
  border-radius: ${props => props.theme.borderRadius.S};
`

interface Props {
  isSelected: boolean
  hideImages?: boolean
  onSelectAll: () => void
}

function CruiseAllLocationsItem({ isSelected, onSelectAll, hideImages }: Props) {
  const intl = useIntl()

  const allDestinationsTitle = intl.formatMessage({
    id: 'SlV2l6gxm8Pbo1JsinCL',
    defaultMessage: 'All destinations',
  })

  const allDestinationsSubtitle = intl.formatMessage({
    id: 'atZF6J3Jts7Fd-cdydk9',
    defaultMessage: 'Cruises all around the world',
  })

  return <ClickableListItem
    onClick={onSelectAll}
    startIcon={!hideImages && <IconContainer>
      <LineGlobeAltIcon />
    </IconContainer>}
    title={<b>{allDestinationsTitle}</b>}
    subtitle={allDestinationsSubtitle}
    endIcon={<CheckboxButton size="large" checked={isSelected} />}
  />
}

export default CruiseAllLocationsItem
